import React, { createContext, useState, useContext, useEffect } from "react";

const LicenseContext = createContext();

export const LicenseProvider = ({ children }) => {
	const [currentLicense, setCurrentLicense] = useState(() => {
		const savedLicense = localStorage.getItem("currentLicense");
		return savedLicense ? JSON.parse(savedLicense) : null;
	});
	const [licensesLoaded, setLicensesLoaded] = useState(
		() => !!localStorage.getItem("currentLicense")
	);

	// Sync currentLicense	 with localStorage whenever it changes
	useEffect(() => {
		if (currentLicense) {
			localStorage.setItem("currentLicense", JSON.stringify(currentLicense));
		} else {
			localStorage.removeItem("currentLicense");
		}
	}, [currentLicense]);

	return (
		<LicenseContext.Provider value={{ currentLicense, setCurrentLicense, licensesLoaded, setLicensesLoaded }}>
			{children}
		</LicenseContext.Provider>
	);
};

export const useLicense = () => useContext(LicenseContext);
